import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import './ModalStyles.css'; // Reusing a generic modal style

const TaskModal = ({ isOpen, onClose, onSave, task, phaseId }) => {
    const [name, setName] = useState(task?.name || '');
    const [description, setDescription] = useState(task?.description || '');
    
    // Profession Search State
    const [searchTerm, setSearchTerm] = useState('');
    const [professionId, setProfessionId] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        setName(task?.name || '');
        setDescription(task?.description || '');
        
        // Populate profession from task (supports DTO with professionName or Entity with profession.name)
        const initialProfessionName = task?.professionName || task?.profession?.name || '';
        const initialProfessionId = task?.professionId || null;

        setSearchTerm(initialProfessionName);
        setProfessionId(initialProfessionId);
    }, [task]);

    // Handle search input change
    const handleSearchChange = async (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        
        // If user modifies text, reset ID until they select from dropdown
        // Alternatively, we could keep ID if they type exact match, but selection is safer.
        // However, if they just correct a typo, we might lose ID. 
        // For now, strict selection is better for data integrity.
        if (value !== (task?.professionName || task?.profession?.name)) {
             setProfessionId(null);
        }

        if (value.length > 1) {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/SearchLocations/searchAll?search=${value}`);
                // Filter only Professions if needed. The API returns items with 'type'.
                // Assuming we only want 'Profession' type for this field.
                const professions = response.data.filter(item => item.type === 'Profession');
                setSearchResults(professions);
                setShowResults(true);
            } catch (error) {
                console.error("Error searching professions", error);
            }
        } else {
            setSearchResults([]);
            setShowResults(false);
        }
    };

    const selectProfession = (item) => {
        setSearchTerm(item.name);
        setProfessionId(item.id); // Assuming search API returns 'id' which maps to profession_id
        setShowResults(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ 
            ...task, 
            id: task?.id, 
            name, 
            description, 
            professionId: professionId,
            // Pass profession object/name for UI update without reload if needed
            professionName: searchTerm,
            profession: { id: professionId, name: searchTerm },
            order: task?.order || 0, 
            phaseId: phaseId 
        });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>{task ? 'Edit Task' : 'Add New Task'}</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name:</label>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>Description:</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="form-group" style={{position: 'relative'}}>
                        <label>Suggested Profession:</label>
                        <input 
                            type="text" 
                            value={searchTerm} 
                            onChange={handleSearchChange} 
                            placeholder="Type to search professions..."
                            autoComplete="off"
                        />
                         {showResults && searchResults.length > 0 && (
                            <ul className="search-results-dropdown" style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                background: 'white',
                                border: '1px solid #ccc',
                                zIndex: 1000,
                                maxHeight: '200px',
                                overflowY: 'auto',
                                listStyle: 'none',
                                padding: 0,
                                margin: 0,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                {searchResults.map((item) => (
                                    <li 
                                        key={item.id} 
                                        onClick={() => selectProfession(item)}
                                        style={{ padding: '8px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                    >
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="modal-actions">
                        <button type="submit" className="save-button">Save</button>
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TaskModal;
